<template>
  <div>
    <!-- Form Submit State Success -->
    <template v-if="formSubmitState === FORM_SUBMIT_STATE.success">
      <section>
        <div class="ds-container ds-margin-y-48 ds-md-margin-y-96">
          <h1 class="ds-heading ds-md-heading-large ds-text-align-center ds-margin-bottom-24">
            {{ formSuccessLabels.thankYouMessage }}
          </h1>
          <p class="ds-text-medium ds-text-align-center">
            {{ formSuccessLabels.weReceivedYourInformationMessage }}
          </p>
        </div>
      </section>
      <InvestorRelationsPressReleases
        v-if="news.length"
        :title="newsTitle"
        :cards="news"
        :link="seeAllNewsLink"
      />
    </template>
    <!-- Form Submit State Start -->
    <section v-else>
      <div class="ds-container ds-margin-y-48 ds-md-margin-y-96">
        <div class="ds-grid ds-justify-content-center">
          <div class="ds-grid__col ds-grid__col--12 ds-md-grid__col--10 ds-lg-grid__col--6">
            <h1 class="ds-heading ds-md-heading-large ds-text-align-center ds-margin-bottom-24">
              {{ title }}
            </h1>
            <RichText
              v-if="description"
              :data="description"
              class="ds-text-medium ds-text-align-center ds-margin-bottom-24 ds-md-margin-bottom-48"
            />

            <DsPlaceholderLoader
              v-if="formFetchStatus === 'pending'"
              theme="grey"
            />
            <ClientOnly>
              <DsForm
                v-if="formFetchStatus !== 'pending' && formFields.length > 0"
                :key="'investor-relations-event-' + formId"
                :form-id="formId"
                :fields="formFields"
                :submit-state="formSubmitState"
                :submit-label="formLabels.formSubmitLabelSignup"
                :submit-success-label="formLabels.formSubmitStateSuccessMessage"
                :submit-fail-label="formLabels.formSubmitStateFailMessage"
                @submit="onFormSubmit"
                @change.once="trackFormInteraction"
              />
            </ClientOnly>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { DsForm, DsPlaceholderLoader } from 'awds'
import { defaultFormProps, useForms } from '../../core/composables/useForms'

const emit = defineEmits(['success'])

const {
  formFields,
  FORM_SUBMIT_STATE,
  formId,
  formSubmitState,
  formFetchStatus,
  formLabels,
  formSubmit,
  trackFormInteraction
} = useForms(() => props.formId, emit)

const props = defineProps({
  ...defaultFormProps,
  title: { type: String, required: true },
  description: { type: Object, required: true },
  formSuccessLabels: { type: Object, required: true },
  news: { type: Array, required: true },
  newsTitle: { type: String, required: true },
  seeAllNewsLink: { type: Object, required: true }
})

const onFormSubmit = (data) => {
  if (data.type) {
    // This is a normal event, discard
    return
  }
  formSubmit(data)
}
</script>
